/* tslint:disable:max-line-length */
import { type SegmentSpecificMessages } from "../../types/types";

export const militaryMessages: SegmentSpecificMessages = {
  emailExplanation: "Personal email address is recommended",
  step: {
    personalInfo: {
      title: "Unlock this Military-Only Offer",
      subtitle: "Verify you're a member of the armed forces.",
      howDoesVerifyingWorkDetails:
        "This offer is available to military personnel who have served or are currently serving in the United States Armed Forces." +
        "<br></br>" +
        "{companyName} uses SheerID, a trusted partner, to verify that you are a member of the military. SheerID only collects information that assists in verifying your eligibility. Additional information or documentation may be requested.",
      tryAgain: {
        title: "Check Your Name & Birthdate",
        subtitle:
          "Enter your first and last name on the form as it appears on your military document(s). Keep in mind that may be your given name.",
      },
      verifyingTitle: "Verifying your military status",
      submitButtonText: "Verify My Military Status",
    },
    docUpload: {
      uploadInstructions: "Upload your government-issued document that shows",
      title: "To continue, upload documents that confirm your military status",
      whoIsSheerId:
        "Document review is handled by SheerID, a trusted partner who specializes in verifying military.",
    },
    success: {
      title: "You've been verified",
      subtitle: "You are now eligible for this special offer.",
      redirectButtonText: "Continue",
    },
  },
};
